// Migrated 1:1 from @nexato/nx-core-module (components/billing-invoice-receiver-view, #685)
import { Component, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { take } from 'rxjs/operators';
import { Tenant } from '../../entities/tenant/tenant';
import { TenantsService } from '../../services/tenants/tenants.service';
import { ToastService } from '../../services/toast/toast.service';
import { UsersService } from '../../services/users/users.service';
import { BillingInvoiceReceiverEditAddressDialogComponent } from '../billing-invoice-receiver-edit-address-dialog/billing-invoice-receiver-edit-address.component';
import { BillingInvoiceReceiverEditEmailDialogComponent } from '../billing-invoice-receiver-edit-email-dialog/billing-invoice-receiver-edit-email.component';
import { ConfirmDialogEventType, ConfirmDialogSeverity } from '../confirmDialog/confirmDialogComponent';
import { ConfirmDialogService } from '../confirmDialog/confirmDialogService';
import { EditDialogService } from '../editDialog/editDialogService';
import * as fromGraphQl from './graphql';

interface Setting {
  key: string;
  value: any;
}

@Component({
  selector: 'app-billing-invoice-receiver-view',
  templateUrl: './billing-invoice-receiver-view.component.html',
  styleUrls: ['./billing-invoice-receiver-view.component.scss']
})
export class BillingInvoiceReceiverViewComponent implements OnInit {

  dialogRef: DynamicDialogRef | undefined;

  public tenant: Tenant;
  public invoiceEmailMenuItems: MenuItem[];
  public invoiceAddressMenuItems: MenuItem[];

  constructor(
    private apollo: Apollo,
    private userSerivce: UsersService,
    public dialogService: EditDialogService,
    private confirmDialogService: ConfirmDialogService,
    private toastService: ToastService,
    private tenantService: TenantsService
  ) {
  }

  ngOnInit(): void {
    this.subscribeToTenantData()
  }

  subscribeToTenantData() {
    this.apollo.query<fromGraphQl.TenantQueryResponse>({
      fetchPolicy: 'network-only',
      query: fromGraphQl.TENANT_QUERY,
      variables: {
        tenantId: this.userSerivce.getCurrentTenantId(),
      },
    }).pipe(
      take(1)
    ).subscribe( (data) => {
      this.tenant = new Tenant(data?.data?.tenant);
      this.buildMenuItems();
    });
  }

  buildMenuItems() {
    this.invoiceEmailMenuItems = [
      {
        label: 'Bearbeiten',
        command: () => {
          this.editInvoiceEmail();
        }
      },
      {
        label: 'Löschen',
        disabled: this.tenant?.invoiceEmail === undefined || this.tenant?.invoiceEmail === null,
        command: () => {
          this.deleteInvoiceEmail();
        }
      }];
    console.log(this.tenant?.invoiceAddress);
    this.invoiceAddressMenuItems = [
      {
        label: 'Bearbeiten',
        command: () => {
          this.editInvoiceAddress();
        }
      },
      {
        label: 'Löschen',
        disabled: this.tenant?.invoiceAddress === undefined || this.tenant?.invoiceAddress === null,
        command: () => {
          this.deleteInvoiceAddress();
        }
      }];
  }

  deleteInvoiceEmail() {
    const message = 'Möchtest Du ' + this.tenant?.invoiceEmail + ' als abweichende Rechnungs-Email-Adresse löschen?';
    this.dialogRef = this.confirmDialogService.open({
      message: message,
      severity: ConfirmDialogSeverity.WARN,
      header: 'E-Mail löschen'
    });
    this.dialogRef.onClose.subscribe( (result : ConfirmDialogEventType) => {
      if(result === ConfirmDialogEventType.CONFIRM){
        this.tenantService?.deleteInvoiceEmail(this.tenant?.id, () => {
          this.subscribeToTenantData();
        })
      };
    })
  }

  editInvoiceEmail() {
    this.dialogRef = this.dialogService.open(BillingInvoiceReceiverEditEmailDialogComponent, {
      header: 'E-Mail-Adresse bearbeiten',
      data: this.tenant
    });
    this.dialogRef.onClose.subscribe((result) => {
      // result is true or false, indiciating if it should refetch
      if(result){
        this.subscribeToTenantData();
      }
    });
  }

  deleteInvoiceAddress() {
    const message = 'Möchtest Du die abweichende Adresse löschen?';
    this.dialogRef = this.confirmDialogService.open({
      message: message,
      severity: ConfirmDialogSeverity.WARN,
      header: 'Adresse löschen'
    });
    this.dialogRef.onClose.subscribe( (result : ConfirmDialogEventType) => {
      if(result === ConfirmDialogEventType.CONFIRM){
        this.tenantService?.deleteInvoiceAddress(this.tenant?.id, () => {
          this.subscribeToTenantData();
        })
      };
    })
  }

  editInvoiceAddress() {
    this.dialogRef = this.dialogService.open(BillingInvoiceReceiverEditAddressDialogComponent, {
      header: 'Adresse bearbeiten',
      data: this.tenant
    });
    this.dialogRef.onClose.subscribe((result) => {
      // result is true or false, indiciating if it should refetch
      if(result){
        this.subscribeToTenantData();
      }
    });
  }

  buildInvoiceAddressRepresentation(address: any): string {
    let representation = '';
    if (address?.name) {
      representation += address.name;
    }
    if (address?.addressLine0) {
      representation += ', ' + address.addressLine0;
    }
    if (address?.addressLine1) {
      representation += ', ' + address.addressLine1;
    }
    if (address?.postalCode) {
      representation += ', ' + address.postalCode;
    }
    if (address?.city) {
      representation += ', ' + address.city;
    }
    if (address?.country) {
      representation += ', ' + address.country;
    }
    if (address?.vatType) {
      representation += ', VAT: ' + this.tenantService.getVatTypeName(address.vatType);
    }
    if (address?.vatNumber) {
      representation += ', VAT: ' + address.vatNumber;
    }
    return representation;
  }


}
